import { useScreenType } from '@/hooks/media';
import { useState, useMemo, useEffect } from 'react';
import { useHomeStore } from '@/store/home';
import { ViewMore } from '@/components/ViewMore';
import { DailyActivityCard } from './DailyActivityCard';
import { useFm } from '@web3/base-hooks';
import { scTrack } from '@web3/base-tracking';
import { Block } from '@/components/Block';
import { Page } from '@/config/track-config';

export function SectionDailyActivity() {
  const { isMobile } = useScreenType();
  const [size, setSize] = useState(9);
  const [page, setPage] = useState(1);
  const [noMore, setNoMore] = useState(false);

  const store = useHomeStore();
  const fm = useFm();

  const loadMore = () => {
    scTrack('Web3UserClick', {
      page_name: Page.AirdropArcadeHome,
      button_name: 'ViewMore',
    });
    const nextPage = page + 1;

    setPage(nextPage);
    setNoMore(nextPage * size > Number(store.dailyActivityList?.length));
  };

  useEffect(() => {
    store.fetchDailyActivityList();
  }, []);

  useEffect(() => {
    setPage(1);
    setSize(isMobile ? 2 : 9);
  }, [isMobile]);

  useEffect(() => {
    setNoMore(Number(store.dailyActivityList?.length) < size);
  }, [store.dailyActivityList, size]);

  const dataList = useMemo(() => {
    return store.dailyActivityList?.slice(0, page * size) || [];
  }, [store.dailyActivityList, page, size]);

  // console.log('-')

  return (
    <>
      {dataList?.length > 0 ? (
        <Block
          className="daily-activity-wrap text-white mt-8 !md:mt-20"
          title={fm('dailyRewards')}
        >
          <ViewMore loadMore={loadMore} noMore={noMore}>
            <div className="daily-activity-list grid md:grid-cols-3 gap-4 !md:gap-6 mt-4 !md:mt-8">
              {dataList?.map((item) => (
                <DailyActivityCard key={item.activityId} data={item} />
              ))}
            </div>
          </ViewMore>
        </Block>
      ) : null}
    </>
  );
}
